module.exports = __webpack_public_path__ + "static/media/mr.695c9908.svg";